import { LOCATION_CHANGE } from 'react-router-redux';
import { HIDE_MODAL } from '../../actions/hide-modal';
import { SHOW_MODAL } from '../../actions/show-modal';
import onLocationChange from './action-handlers/on-location-change';
import onShowModal from './action-handlers/on-show-modal';
import onHideModal from './action-handlers/on-hide-modal';

export default {
  [LOCATION_CHANGE]: onLocationChange,
  [SHOW_MODAL]: onShowModal,
  [HIDE_MODAL]: onHideModal,
};
